import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import ui from './modules/ui.js'
import sensors from "./modules/sensors.js";
import createLogger from 'vuex/dist/logger';
import * as localData from '@/services/localData.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    ui,
    sensors,
  },
  strict: debug,
  // plugins: debug? [ createLogger() ] : [],
  state: {},
  mutations: {},
  actions: {},
});
